import{
    CREATE_SESSION_ERROR,
    CREATE_SESSION_SUCCESS,
    DELETE_SESSION_ERROR,
    DELETE_SESSION_SUCCESS,
    FETCH_SESSIONS_ERROR,
    FETCH_SESSIONS_SUCCESS,
    UPDATE_SESSION_ERROR,
    UPDATE_SESSION_SUCCESS

} from './types';
const initialState = {
    loading: false,
    data: [],
    error: "",
  };
  export default function eventReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_SESSIONS_SUCCESS:
        return {
          ...state,
          loading: false,
          data: [...action.payload],
          error: "",
        };
      case FETCH_SESSIONS_ERROR:
        return {
          ...state,
          data: [],
          loading: false,
          error: action.payload,
        };
  
      case CREATE_SESSION_SUCCESS:
        return {
          ...state,
          data: [...state.data, action.payload],
          loading: false,
          error: "",
        };
      case CREATE_SESSION_ERROR:
        return {
          ...state,
          data: [],
          loading: false,
          error: action.payload,
        };
  
      case UPDATE_SESSION_SUCCESS:
        return {
          ...state,
          data: [
            ...state.data.map((category) => {
              if (category._id === action.payload._id) return action.payload;
              else return category;
            }),
          ],
          loading: false,
          error: "",
        };
      case UPDATE_SESSION_ERROR:
        return {
          ...state,
          data: [],
          loading: false,
          error: action.payload,
        };
      case DELETE_SESSION_SUCCESS:
        return {
          ...state,
          loading: false,
          data: [
            ...state.data.filter((category) => category._id !== action.payload),
          ],
          error: "",
        };
      case DELETE_SESSION_ERROR:
        return {
          ...state,
          data: [],
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
}